import request from "@/CommonDP/utils/request";
export default {
    //获取树
    getFolderTree(prjId,enterpriseId) {
      return request.get(`/bimAdministration/getFolderTree?prjId=${prjId}&enterpriseId=${enterpriseId}`);
    },

    addBIMManangerFolder(params) {
      return request.post(`/bimAdministration/addBIMManangerFolder`,params);
    },
    updateBIMManangerFolder(folderId,folderName) {
      return request.post(`/bimAdministration/updateBIMManangerFolder?folderId=${folderId}&folderName=${folderName}`);
    },

    delBIMManangerFolder(folderId) {
      return request.post(`/bimAdministration/delBIMManangerFolder?folderId=${folderId}`);
    },

    getMoDelByNodeId(nodeId) {
      return request.get(`/bimAdministration/getMoDelByNodeId?nodeId=${nodeId}`);
    },

    addMoDel(params) {
      return request.post(`/bimAdministration/addMoDel`,params);
    },

    delModelById(nodePid,params) {
      return request.post(`/bimAdministration/delModelById?nodePid=${nodePid}`,params);
    },
}